import { Stack, Text } from '@mantine/core';
import * as React from 'react';
import { ValidationEntrySeverity } from '../../../../../../react-commons/components/ValidationEntrySeverity';
import { ControlledInputs } from '../../../../../../react-commons/utils/read-only-inputs/controlledInputs';
import {
    BackgroundExportTaskResult,
    BackgroundImportTaskResult,
    BackgroundNormalTaskResult,
    BackgroundValidatedExportTaskResult,
} from '../../../../resource/services/backgroundTaskResource';
import { ProjectImportValidationResultComponent } from '../../../reusable-components/dialogs/validation/ProjectImportValidationResultComponent';
import { ValidatedExportResultComponent } from '../../../reusable-components/dialogs/validation/ValidatedExportResultComponent';

export const BackgroundTaskInfoDialogContent= ({ backgroundTaskResult }: {
    backgroundTaskResult:
        | BackgroundNormalTaskResult
        | BackgroundImportTaskResult
        | BackgroundValidatedExportTaskResult
        | BackgroundExportTaskResult;
}) => {
    return (
        <Stack w={'100%'}>
            <div style={{ display: 'inline-flex' }}>
                <Text style={{ minWidth: 200 }}>Successful</Text>
                {backgroundTaskResult.successful ?
                    <ControlledInputs.String
                        nullable={false}
                        style={{ minWidth: 500 }}
                        readOnly={true}
                        value={'TRUE'}
                    />
                :   <ControlledInputs.String
                        nullable={false}
                        style={{ minWidth: 500 }}
                        readOnly={true}
                        value={'FALSE'}
                        severity={ValidationEntrySeverity.CRITICAL}
                    />
                }
            </div>
            {backgroundTaskResult.failureReason && (
                <div style={{ display: 'inline-flex' }}>
                    <Text style={{ minWidth: 200 }}>Failure Reason</Text>
                    <ControlledInputs.String
                        nullable={false}
                        style={{ minWidth: 500 }}
                        readOnly={true}
                        value={backgroundTaskResult.failureReason}
                    />
                </div>
            )}
            {backgroundTaskResult.failureMessage && (
                <div style={{ display: 'inline-flex', width: '100%' }}>
                    <Text style={{ minWidth: 200 }}>Exception Message</Text>
                    <ControlledInputs.MultilineString
                        style={{ minWidth: 800 }}
                        maxRows={
                            backgroundTaskResult.failureMessage.length / 200 < 3 ? 3
                            : backgroundTaskResult.failureMessage.length / 200 > 25 ?
                                25
                            :   backgroundTaskResult.failureMessage.length / 200
                        }
                        nullable={false}
                        readOnly={true}
                        value={backgroundTaskResult.failureMessage}
                    />
                </div>
            )}
            {backgroundTaskResult.type === 'IMPORT' && (
                <ProjectImportValidationResultComponent importTaskResult={backgroundTaskResult} />
            )}
            {backgroundTaskResult.type === 'VALIDATED_EXPORT' && (
                <ValidatedExportResultComponent validatedExportTaskResult={backgroundTaskResult} />
            )}
            {/*TODO backgroundTaskResult.type === 'EXPORT' && (
                    <Grid item xs={12}>
                        <></>
                    </Grid>
                )*/}
        </Stack>
    );
};


